import axios from "axios";
import {BASE_URL} from "@/constant";
const url = BASE_URL + "/api";

const jwtConfig = () => ({
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
});

const configForMultipart = (onUploadProgress) => ({
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
    "Content-Type": "multipart/form-data",
  },
  onUploadProgress: onUploadProgress,
});

export default {
  save(book) {
    return axios.post(`${url}/book`, book, jwtConfig());
  },

  saveBook(id, file, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      `${url}/book/${id}`,
      formData,
      configForMultipart(onUploadProgress)
    );
  },

  delete(book) {
    return axios.delete(`${url}/book/${book.id}`, jwtConfig());
  },
  upload(file, onUploadProgress) {
    let formData = new FormData()
    formData.append('file', file)
    return axios.post(
        `${url}/book/upload`,
        formData,
        configForMultipart(onUploadProgress)
    )
  },
  getAll(pageable, criteria) {
    let resUrl = `?page=${pageable.page}&size=${pageable.size}&sort=${pageable.sortBy},${pageable.sort}`;
    if (criteria != null) {
      resUrl += criteria.name
        ? `&name=${criteria.name}`
        : "" + criteria.author
        ? `&author=${criteria.author}`
        : "" + criteria.departmentId
        ? `&departmentId=${criteria.departmentId}`
        : "" + criteria.categoryId
        ? `&categoryId=${criteria.categoryId}`
        : "";
    }
    return axios.get(`${url}/user/book${resUrl}`);
  },

  getOne(id) {
    return axios.get(`${url}/user/book/${id}`);
  },
};
